import { Box, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { useAuth } from '@verantos-dev/core-annotation-tool';

import { DashboardCard } from './DashboardCard';
import { useAdminCardsSection } from './useAdminCardsSection';
import { useNavOnDashboard } from './useNavOnDashboard';

export const AdminCardsSection = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const { navigateToAdminProjects } = useNavOnDashboard();
  const { user } = useAuth();
  const { totalProjectsCount, isTotalProjectsCountLoading } = useAdminCardsSection();

  if (!user.isAdmin || isTotalProjectsCountLoading) {
    return null;
  }

  return (
    <Box sx={{ mt: theme.spacing(6) }}>
      <Box sx={{ mb: theme.spacing(6) }}>
        <Typography variant="h5">
          {formatMessage({ id: 'annotationDashboard.administration.cardsSection.title' })}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', width: '100%', gap: theme.spacing(6) }}>
        {/* Card - Manage projects */}
        <DashboardCard
          title={formatMessage({
            id: 'annotationDashboard.administration.manageProjects.card.title',
          })}
          borderColor={theme.palette.deeppurple[500]}
          onClickHandler={navigateToAdminProjects}
          value={totalProjectsCount}
          description={formatMessage({
            id: 'annotationDashboard.administration.manageProjects.card.description',
          })}
        />

        {/* Card - Manage users */}
        {/* <DashboardCard
        title={formatMessage({ 'id' : 'annotationDashboard.administration.manageUsers.card.title' })}
        borderColor={theme.palette.deeppurple[500]}
        onClickHandler={(e) => {e.preventDefault(); console.log("clicked")}}
        value={totalUsersCount}
        isLoading={isTotalUsersCountLoading}
      /> */}

        {/* Card - My organizations */}
        {/* <DashboardCard
        title={formatMessage({ 'id' : 'annotationDashboard.administration.myOrganizations.card.title' })}
        borderColor={theme.palette.deeppurple[500]}
        onClickHandler={(e) => {e.preventDefault(); console.log("clicked")}}
        value={organizationsCount}
        isLoading={isOrganizationsCountLoading}
      /> */}

        {/* Card - Manage conditions */}
        {/* <DashboardCard
        title={formatMessage({ 'id' : 'annotationDashboard.administration.manageConditions.card.title' })}
        borderColor={theme.palette.deeppurple[500]}
        onClickHandler={(e) => {e.preventDefault(); console.log("clicked")}}
        value={conditionsCount}
        isLoading={isConditionsCountLoading}
      /> */}
      </Box>
    </Box>
  );
};
